import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

export default function TitleBox({ data }) {
  const classes = useStyles();

  return (
    <>
      <Card
        className={classes.box}
        sx={{
          border: "1px solid #DEDEDE ",
          width: "23vw !important",
          height: "100px",
          borderRadius: "8px",
          flexWrap: "nowrap",
        }}
      >
        <CardContent style={{ flexWrap: "nowrap" }}>
          <Typography
            className={classes.typobox}
            sx={{
              width: "205px",
              height: "24px",
              marginBottom: "10px",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            color="text.secondary"
          >
            {data?.title}
          </Typography>
          <Typography
            variant="h5"
            fontWeight={600}
            sx={{
              width: "42px",
              height: "39px",
              fontStyle: "normal",
              fontSize: "32px",
              lineHeight: "39px",
              color: "#111111",
            }}
          >
            {data?.number}
          </Typography>
        </CardContent>
        <CardActions></CardActions>
      </Card>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  box: {
    ["@media (max-width:768px)"]: {
      padding: " 0 7rem 0 7rem",
    },
  },

  typobox: {
    ["@media (max-width:768px)"]: {
      margin: "0 -1.5rem ",
    },
  },
}));
